export default {
  model: [
    {
      label: 'Descrição',
      field: 'description',
      type: 'text'
    },
    {
      label: 'Metodo',
      field: 'method',
      type: 'text'
    },
    {
      label: 'Valor mínimo',
      field: 'min_value',
      type: 'text'
    },
  ]
}
